let currentPixiApp = null
export let pixiApp

const waitForPixiContainer = (maxAttempts = 60) => new Promise((resolve, reject) => {
  let attempts = 0

  const checkContainer = () => {
    const container = document.getElementById('pixi-plinko-game')
    if (container) {
      resolve(container)
      return
    }

    attempts += 1
    if (attempts >= maxAttempts) {
      reject(new Error('Pixi container #pixi-plinko-game not found'))
      return
    }

    window.requestAnimationFrame(checkContainer)
  }

  checkContainer()
})

const loadAssetsPixi = () =>
  import('./assetsLoad.js')
    .then(({ default: loadAssets }) => loadAssets())
    .catch((error) => {
      console.error('Error during assets loading in Pixi:', error)
      throw error
    })

const loadPixiApp = () =>
  import('./appPixi.js')
    .then(({ default: createPixiApp }) => {
      if (currentPixiApp) {
        currentPixiApp.destroyPixi(true)
      }

      pixiApp = createPixiApp()
      currentPixiApp = pixiApp

      console.log('Pixi app loaded!')
      return pixiApp
    })
    .catch((error) => {
      console.error('Error during Pixi.js initialization:', error)
      throw error
    })

const loadGameUI = () =>
  import('./gameUI.js')
    .then(({ createUI }) => {
      createUI()
      console.log('Game UI created!')
    })
    .catch((error) => {
      console.error('Error loading gameUI.js:', error)
      throw error
    })

const gameTickerStart = () =>
  import('./gameLogic.js')
    .then(({ startGameTicker }) => {
      startGameTicker()
      console.log('Game Ticker Started!')
    })
    .catch((error) => {
      console.error('Error loading gameLogic.js:', error)
      throw error
    })

export const loadPixiAssets = () =>
  loadAssetsPixi()
    .then(() => console.log())
    .catch((error) => {
      console.error('Error loading pixi assets:', error)
    })

let initPromise = null

export const destroyPixiApp = () => {
  console.log('[Plinko Init] Destroying Pixi Application & clearing startup state...')
  initPromise = null
  if (currentPixiApp) {
    try {
      currentPixiApp.destroyPixi()
    } catch (err) {
      console.warn('[Plinko Init] Warning during Pixi app destruction:', err)
    }
    currentPixiApp = null
    pixiApp = null
  }
}

export const init = (setIsPixiAssetsLoaded) => {
  if (initPromise) {
    console.log('[Plinko Init] Initialization already in progress, awaiting existing run...')
    return initPromise
  }

  if (typeof setIsPixiAssetsLoaded === 'function') {
    setIsPixiAssetsLoaded(false)
  }

  console.log('[Plinko Init] Starting startup sequence...')

  initPromise = (async () => {
    try {
      console.log('[Plinko Init] Step 1/5: Loading Assets')
      await loadAssetsPixi()

      console.log('[Plinko Init] Step 2/5: Finding DOM Container')
      await waitForPixiContainer()

      console.log('[Plinko Init] Step 3/5: Creating Pixi Application')
      await loadPixiApp()
      if (currentPixiApp?.resizePixiApp) {
        currentPixiApp.resizePixiApp(2000)
      }

      console.log('[Plinko Init] Step 4/5: Initializing Game UI & Matter World')
      await loadGameUI()

      console.log('[Plinko Init] Step 5/5: Starting Game Ticker')
      await gameTickerStart()

      if (typeof setIsPixiAssetsLoaded === 'function') {
        setIsPixiAssetsLoaded(true)
      }

      console.log('[Plinko Init] Startup sequence completed successfully!')
    } catch (error) {
      console.error('[Plinko Init] Startup sequence failed:', error)
      if (typeof setIsPixiAssetsLoaded === 'function') {
        setIsPixiAssetsLoaded(false)
      }
      destroyPixiApp()
      throw error
    } finally {
      initPromise = null
    }
  })()

  return initPromise
}

let gameUIModule

export const loadGameUIFunctions = () => {
  if (!gameUIModule) {
    return import('./gameUI.js')
      .then((module) => {
        gameUIModule = module
        return gameUIModule
      })
      .catch((error) => {
        console.error('Error loading GameUI.js:', error)
        throw error
      })
  }

  return Promise.resolve(gameUIModule)
}
